import { useQuery } from '@tanstack/react-query';
import { remixApi } from '@tectonic/api-client';
import { toProductSearchRequestPayload } from '@tectonic/utils';
import { queryKeys } from '../../queryKeys';

import type { SearchQuerySource } from '@tectonic/types';

const useCollectionProductSearch = (
  widgetId: number | string,
  {
    slug,
    perPage,
    source,
  }: { slug?: string; perPage?: number; source?: SearchQuerySource }
) => {
  if (!slug) {
    throw new Error('useCollectionProductSearch: collection is required');
  }

  const pp = perPage ?? 10;

  const query = { perPage: pp };

  const { data: collection } = useQuery({
    queryKey: queryKeys.collection(slug),
    queryFn: async () => remixApi.getCollection(slug),
  });

  const { data, ...rest } = useQuery({
    enabled: !!collection,
    queryKey: queryKeys.collectionSearch(slug, widgetId),
    queryFn: async () =>
      remixApi.searchCollection(
        toProductSearchRequestPayload({
          ...(collection!.source ? collection!.source.query! : {}),
          ...(source?.query ?? {}),
          ...query,
        }),
        slug
      ),
  });

  return {
    perPage: pp,
    ...data,
    ...rest,
  };
};

export { useCollectionProductSearch };
